import { Maybe } from '@/__generated__/graphql';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import { Image } from '@/components/Analysis//shared/Image';

type PoiImageProps = {
  viewpointImage?: Maybe<string>;
  viewerImage?: Maybe<string>;
};

const imageStyles = {
  width: '100%',
  maxHeight: '20rem',
  backgroundColor: '#283238',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 4,
  overFlow: 'hidden',
};

const containerStyles = { ...imageStyles, backgroundColor: 'transparent', marginTop: '2.4rem' };

export const PoiImage = ({ viewpointImage, viewerImage }: PoiImageProps) => {
  return viewpointImage ? (
    <Image
      src={getCloudfrontUrl(viewpointImage)}
      alt="Viewpoint"
      imgSx={imageStyles}
      sx={containerStyles}
    />
  ) : viewerImage ? (
    <Image
      src={getCloudfrontUrl(viewerImage)}
      alt="Viewer"
      imgSx={imageStyles}
      sx={containerStyles}
    />
  ) : (
    <></>
  );
};
